import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import { Route, Switch } from 'react-router';
import { ConnectedRouter, push } from 'connected-react-router';
import { dependencies } from '../index';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import Dashboard from './Dashboard/Dashboard';
import Login from './Login/Login';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import Interceptor from './Interceptor';
import User from './Dashboard/User/User';
import PrivateRoute from './PrivateRoute';
import SpaceListing from './SpaceListing/SpacesListing';

function App() {
  const [cookies, setCookie] = useCookies(['token']);
  const [customPathName, setPathName] = useState(null);
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.auth?.data?.token || null);
  const email = useSelector((state) => state?.auth?.data?.email || null);

  useEffect(() => {
    if (token) {
      setCookie('token', token, { path: '/' });
      localStorage.setItem('email', email);
      dispatch(push('/dashboard/space/space'));
    }
  }, [token, email]);

  return (
    <div className="App ms-styles-wrapper">
      <>
        <ErrorBoundary>
          <Interceptor />
          <ConnectedRouter history={dependencies.history}>
            <Suspense fallback={null}>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/spacelist" component={SpaceListing} />
                <PrivateRoute
                  path="/dashboard"
                  component={Dashboard}
                  isAuthenticated={cookies.token ? true : false}
                  redirectPath="/"
                />
              </Switch>
            </Suspense>
          </ConnectedRouter>
        </ErrorBoundary>
      </>
    </div>
  );
}

export default App;
